var SENTRY_RELEASE;SENTRY_RELEASE={name: "Ariadna", version: "1.6.3"};